module.exports = __webpack_public_path__ + "img/tiger-machine-panel-light-2.ec9ac955.svg";